import React from 'react';
import { keyCodes } from '../../../constants';
import IconButton from '../../icon-button';

// @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: a... Remove this comment to see the full error message
const ActionGroup = ({
  editLabel = '',
  deleteLabel = '',
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: any[]) => any'.
  onEditClick = null,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: any[]) => any'.
  onDeleteClick = null,
}) => {
  const isEditIconButtonEnabled = !!onEditClick;
  const isDeleteIconButtonEnabled = !!onDeleteClick;

  if (!isEditIconButtonEnabled && !isDeleteIconButtonEnabled) return null;

  const handleEditClick = (e) => {
    e.stopPropagation();
    onEditClick();
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    onDeleteClick();
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === keyCodes.SPACE || e.keyCode === keyCodes.ENTER) {
      e.stopPropagation();
    }
  };

  return (
    <div className="ws-ui-preset-container__action-group" onKeyDown={handleKeyDown}>
      {isEditIconButtonEnabled && (
        <IconButton
          glyph="settings"
          appearance="accent"
          size="medium"
          // @ts-ignore TS(2322): Type 'string' is not assignable to type 'null | un... Remove this comment to see the full error message
          label={editLabel}
          // @ts-ignore TS(2322): Type 'true' is not assignable to type 'null | unde... Remove this comment to see the full error message
          transparent
          // @ts-ignore TS(2322): Type '(e: any) => void' is not assignable to type ... Remove this comment to see the full error message
          onClick={handleEditClick}
        />
      )}
      {isDeleteIconButtonEnabled && (
        <IconButton
          glyph="trash"
          appearance="accent"
          size="medium"
          // @ts-ignore TS(2322): Type 'string' is not assignable to type 'null | un... Remove this comment to see the full error message
          label={deleteLabel}
          // @ts-ignore TS(2322): Type 'true' is not assignable to type 'null | unde... Remove this comment to see the full error message
          transparent
          // @ts-ignore TS(2322): Type '(e: any) => void' is not assignable to type ... Remove this comment to see the full error message
          onClick={handleDeleteClick}
        />
      )}
    </div>
  );
};

export default ActionGroup;
